/**
 * ShowroomHeader
 *
 * Presentational header for the Showroom experience.
 * Left side renders the buyer name placeholder and an "Add Co-Buyer" CTA.
 * Right side renders the Share dropdown (Credit App / Doc Upload).
 */

import { useHeaderNavbarConfig } from '../../hooks/useHeaderNavbarConfig';

import DealershipHeader from '../DealershipHeader/DealershipHeader';
import NavBar from '../NavBar/NavBar';

const Header = () => {
    const { topNavItems, dealershipHeaderConfig } = useHeaderNavbarConfig();

    return (
        <div data-testid="header-root">
            <DealershipHeader config={dealershipHeaderConfig} />

            <NavBar topNavItems={topNavItems} />
        </div>
    );
};

export default Header;
